import { useNavigate } from "react-router-dom";

import { PATHS } from "../../../config/routeConfig";
import { ConfirmationAnswer } from "../../../context/vulnerability/VulnerabilityContext";
import { useVulnerabilityContext } from "../../../context/vulnerability/useVulnerabilityContext";
import { questionContent } from "../questions";
import ConfirmationWithDetailQuestion from "../../../components/Questions/ConfirmationWithDetailQuestion";

const DailySupport: React.FC = () => {
  const { answers, setAnswers } = useVulnerabilityContext();
  const navigate = useNavigate();

  const onChange = (answer?: ConfirmationAnswer, detail?: string) => {
    setAnswers({
      ...answers,
      dailySupport: answer ?? answers.dailySupport,
      dailySupportDetail:
        answers.dailySupport !== ConfirmationAnswer.Yes ? undefined : detail,
    });
  };

  const onContinue = () => {
    navigate(`/${PATHS.Summary}`);
  };

  return (
    <ConfirmationWithDetailQuestion
      onChange={onChange}
      value={answers.dailySupport}
      detail={answers.dailySupportDetail}
      onContinue={onContinue}
      step={questionContent.dailySupport.step}
      title={questionContent.dailySupport.title}
      whyWeWantTexts={questionContent.dailySupport.whyWeWantTextsCustomer}
      placeholder={"Please let us know what support you have on a daily basis"}
    />
  );
};

export default DailySupport;
